<template>
  <div class="print">

    <div class="right-wrap">
      <div class="right-wrap-header">
        <div class="search">
          <div class="qjc-flex">
            <el-input v-model="nowMobile" placeholder="请输入手机号" class="qjc-fts-14" @input="accountInput">
              <div class="search-icon" slot="prefix">
                <i class="el-icon-search"></i>
              </div>
            </el-input>
            <div class="query-date">
              <div class="query-date-label">{{ $t('table.t15') }}</div>
              <el-date-picker v-model="dateValue" type="daterange" value-format="timestamp" range-separator="~"
                :start-placeholder="$t('table.t12')" :end-placeholder="$t('table.t13')" @change="searchDateChange">
              </el-date-picker>
            </div>
          </div>
          <el-button type="primary" size="normal" @click="query" class="">{{ $t('table.t39') }}</el-button>
          <el-button @click="handleRet" class="">{{ $t('table.t40') }}</el-button>
        </div>
        <div>
          <el-row :gutter="20" v-show="downFile">
            <el-col :span="12">
              <button type="submit" class="download-excel nextBtn" @click="downExcel">批量导出</button>
              <form :action="http" method="post" autocomplete="off" v-show="false">
                <input type="text" name="mobile" :value="nowMobile" />
                <input type="text" name="startat" :value="dateValue[0] ? dateValue[0] / 1000 : ''" />
                <input type="text" name="endat" :value="dateValue[1] ? dateValue[1] / 1000 + 86399 : ''" />
                <button type="submit" ref="down">批量导出</button>
              </form>
            </el-col>
          </el-row>
        </div>
      </div>


      <el-table :data="user" class="list">

        <!-- :height="mainHeight-188+'px'" -->
        <template slot="empty">
          <div class="empty-wrap">
            <el-image class="empty-img" :src="require('@/assets/images/empty-download.png')"></el-image>
            <div class="empty-text">暂无数据</div>
          </div>
        </template>

        <el-table-column prop="id" :label="$t('table.t1')" min-width="60">
          <template slot-scope="scope">
            {{ scope.row.id ? scope.row.id : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('table.t2')" class-name="mobile" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.mobile ? scope.row.mobile : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="age" label="年龄" class-name="mobile" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.age ? scope.row.age : '--' }}
          </template>
        </el-table-column>



        <el-table-column prop="sex" :label="$t('table.t4')" class-name="sex" min-width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.sex == 1">男</div>
            <div v-else-if="scope.row.sex == 2">女</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column prop="birth" :label="$t('table.t5')" class-name="birth" min-width="120">

        </el-table-column>



        <el-table-column prop="created_at" :label="$t('table.t15')" class-name="created_at" min-width="160px">
          <template slot-scope="scope">
            {{ scope.row.created_at ? scope.row.created_at : '--' }}
          </template>
        </el-table-column>
        <el-table-column class-name="oper" prop="oper" :label="$t('table.t9')" min-width="140px" fixed="right">
          <template slot-scope="scope">
            <el-button class="btn-text" @click="handleView(scope.row.id)" type="text">{{ $t('table.t41') }}</el-button>

          </template>
        </el-table-column>

      </el-table>


      <el-pagination prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" hide-on-single-page
        :current-page.sync="pager.page" :page-count="pager.pagecount" :page-size="pager.pagesize" :total="pager.count"
        @current-change="pageChange">
      </el-pagination>

      <Alertb :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
        @on-confirm="confirmDialog" />

      <iframe id="iframe" class="qjc-wid-100 qjc-hei-100" :src="iframeUrl" frameborder="0"></iframe>

      <!-- 未安装打印插件 -->
      <div class="no-print qjc-fixed qjc-hide">
        <div class="qjc-absolute qjc-bg-fff qjc-texta-r">
          <p class="qjc-texta-l">未安装打印插件，请先安装</p>
          <span class="qjc-c-primary">关闭</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReportList, enterpriseList, api } from '@/utils/axios'
import Alertb from '@/components/alertb';

export default {
  name: 'mainReportPrint',
  components: {
    Alertb
  },
  data () {
    return {
      searchTag: '',//查询id或手机号
      mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
      user: [],// 客户信息

      submiting: false,//正在请求

      pager: {
        count: 0,
        page: 1,// 默认第一页
        pagecount: 0,
        pagesize: 10//默认一页10条数据
      },

      nowMobile: '',// 存储当前已查询企业用户id或手机号

      iframeUrl: '',// 下载报告路径

      companyList: [],
      enpId: '',
      dateValue: '',
      downFile: false,
      value: '0',
      http: api + '/v1/admin/exportExcel/',
      alertShow: false,
      tipStatus: '',
      tipText: '',
      adminId: '',
      userInfo: null,
      downFile: true,
    }
  },
  mounted () {
    // 获取企业列表
    let adminId = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).issupper : '0'
    this.adminId = adminId
    // 获取企业列表

    this.getList()

    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo)
    }
  },
  watch: {

  },
  methods: {
    getAllText () {
      const allText = document.body.innerText;
    },
    customFun (data) {
      let name = '';
      data.map((item) => {
        if (item == 'base') {
          name = name + '基础体检套餐，'
        }
        if (item == 'mlev') {
          name = name + '增值包-通用健康评分，'
        }
        if (item == 'packageA') {
          name = name + '增值包-同族群PLM对比，'
        }
        if (item == 'packageB') {
          name = name + '增值包-共病风险，'
        }
        if (item == 'packageC') {
          name = name + '增值包-疾病风险远期预测，'
        }
        if (item == 'packageD') {
          name = name + '增值包-健康促进方案，'
        }
        if (item == 'packageFB') {
          name = name + '增值包-骨折风险评估，'
        }
      })

      return name.substring(0, name.length - 1)
    },
    accountInput (val) {
      let codeReg = new RegExp("[A-Za-z0-9]+");
      let len = val.length;
      let str = '';
      for (let i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i]
        }
      }
      this.nowMobile = str
      this.pager.page = 1
    },
    handleEnp (id) {
      this.enpId = id
      this.nowMobile = ''
      this.dateValue = ''
      this.getList()
    },
    handleSelectionChange (val) {
    },
    downExcel () {

      this.$refs.down.click();

    },
    confirmDialog () {
      this.alertShow = false;
    },
    closeDialog () {
      this.alertShow = false;
      //把绑定的弹窗数组 设为false即可关闭弹窗
    },
    searchDateChange (val) {
      this.pager.page = 1
    },
    query () {
      this.pager.page = 1

      this.getList();
    },
    handleRet () {
      this.nowMobile = ''
      this.dateValue = ''
      this.pager.page = 1
      this.getList()
      this.getAllText()
    },
    pageChange (page) {
      this.pager.page = page;
      this.getList();
    },

    getList () {
      let data = {}
      if (this.adminId == 1) {
        data = {
          mobile: this.nowMobile,
          startat: this.dateValue ? this.dateValue[0] / 1000 : '',
          endat: this.dateValue ? this.dateValue[1] / 1000 + 86399 : '',
          page: this.pager.page,
          pagesize: this.pager.pagesize,
          act: 'Report-Download'
        }
      } else {
        data = {
          mobile: this.nowMobile,
          startat: this.dateValue ? this.dateValue[0] / 1000 : '',
          endat: this.dateValue ? this.dateValue[1] / 1000 + 86399 : '',
          page: this.pager.page,
          pagesize: this.pager.pagesize,
          act: 'Report-Download'
        }
      }
      console.log("data", data);
      getReportList(data).then(res => {
        if (res.code == 200) {
          const result = JSON.parse(window.atob(res.data))
          if (result.data.length == 0) {
            this.user = [];
            this.pager = {
              count: 0,
              page: 1,// 默认第一页
              pagecount: 0,
              pagesize: 10//默认一页10条数据
            }
          } else {
            this.user = result.data;
            console.log("getReportList", this.user);

            //分页
            var pager = result.pager;
            for (var key in pager) {
              pager[key] = parseInt(pager[key]);
            }
            this.pager = pager;
          }
        } else {
          this.$myAlert({
            type: 'fail',
            content: res.msg
          });
        }
      });
    },
    hanleLoadAll () {
      // this.enpId = 0,
      this.nowMobile = '';
      this.dateValue = '';
      this.getList();
    },
    // 时间戳转换日期
    timestampFormat (timestamp) {
      let dt = new Date(timestamp * 1000),
        y = dt.getFullYear(),
        m = dt.getMonth() + 1 >= 10 ? dt.getMonth() + 1 : ('0' + (dt.getMonth() + 1)),
        d = dt.getDate() >= 10 ? dt.getDate() : ('0' + dt.getDate());

      return y + '/' + m + '/' + d;
    },

    lookReport (id, pk, type) {
      let complex = ""

      if (this.userInfo && this.userInfo.username == 'medintw') {
        complex = "Complex"
      }

      if (pk && pk == 3) {// 母婴
        window.open('/muying/report/classify.html?id=' + id);
      } else if (pk && pk == 5) { //AI健康
        window.open(`/kyzc/lookReport${complex}.html?id=` + id);
      } else if (pk && pk == 6) { //AI骨折
        window.open(`/fb/lookReport${complex}.html?id=` + id);
      } else if (pk && pk == 7) { //AI骨折
        window.open(`/baijin/lookReport${complex}.html?id=` + id);
      } else if (type && type == 'M22') {
        window.open(`/m22/lookReport.html?id=` + id);

        return
      } else {
        let openUrl = this.$router.resolve({
          path: "/reportPrint/lookReport",
          query: {
            id: id
          }
        });

        window.open(openUrl.href);
      }

    },
    // 下载报告
    download (id, pk, type) {
      var iframeDoc = document.getElementById('iframe'),
        url = '';

      let complex = ""

      if (this.userInfo && this.userInfo.username == 'medintw') {
        complex = "Complex"
      }
      if (pk && pk == 3) {// 母婴
        // url = "/muying/report/download.html?type=download&id="+id;
        window.open("/muying/report/download.html?type=download&id=" + id);
        return
      } else if (pk && pk == 5) {

        window.open(`/kyzc/download${complex}.html?id=` + id);

        return
      } else if (pk && pk == 6) {
        window.open(`/fb/download${complex}.html?id=` + id);

        return
      } else if (pk && pk == 7) {
        window.open(`/baijin/download${complex}.html?id=` + id);

        return
      } else if (type && type == 'M22') {
        window.open('/m22/download.html?id=' + id);

        return
      } else {
        window.open("/#/reportPrint/printTemplate?type=download&id=" + id);

        return
      }


    },
    handleView (id) {
      window.open("/#/archives/detail?id=" + id);
      // this.$router.push({
      //   name: "archivesDetailIndex",
      //   query: {
      //     id: id
      //   }
      // });
    },
    //打印报告
    print (id, pk) {
      var iframeDoc = document.getElementById('iframe'),
        url = '';
      if (pk && pk == 3) {// 母婴
        url = "/muying/report/download.html?type=print&id=" + id;
      } else {
        url = this.$router.resolve({
          path: "/reportPrint/printTemplate",
          query: {
            id: id,
            type: 'print'
          }
        }).href;
      }

      if (this.iframeUrl == url && iframeDoc.contentWindow.getData) {
        iframeDoc.contentWindow.getData();
      } else {
        this.iframeUrl = url;
      }

    }
  }
}
</script>

<style scoped>
.search>>>.el-input-group__prepend {
  width: 112px;
}

.search>>>.el-input__inner {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  /* padding: 10px 12px; */
  background-color: transparent;
}

.search>>>.el-select .el-input__inner {
  text-align: center;
  padding-right: 25px;
}

.search>>>.el-select .el-input__suffix {
  right: 0;
}

.search>>>.el-select .el-icon-arrow-up {
  line-height: 1;
}

.search>>>.el-range-editor .el-range-input {
  background-color: transparent;
}

.list>>>.el-table__body,
.list>>>.el-table__footer,
.list>>>.el-table__header {
  table-layout: auto;
}

.list>>>table {
  /* width: 10.92px; */
}

.list.el-table--striped>>>.el-table__body tr.el-table__row--striped td,
.list>>>thead th {
  background: #FAFBFC;
}

.list>>>.cell {
  /* padding-left: 24px; */
  padding-right: 0;
}

.list>>>thead th {
  /* display: inline-block; */
  color: #40444D;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  border-bottom: none;
}

.list>>>td {
  color: #777F8F;
  font-size: 14px;

}

.list>>>.package .cell {
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pagination>>>button {
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.pagination>>>button .el-icon {
  font-size: 14px;
}

.pagination>>>li {
  width: 32px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-weight: 400;
  color: #40444D;
  border: 1px solid transparent;
  border-radius: 8px;
  margin: 0 6px;
  padding: 0;
  overflow: visible;
}

.pagination>>>li:hover,
.pagination>>>li.active {
  color: #6681FA;
  font-weight: 600;
  border-color: #6681FA;
  border-left: 1px solid #6681FA;
}

.query-date>>>.el-range-separator {
  color: #DBDDE6;
}

.list>>>.el-button:active {
  background-color: transparent !important;
  color: #5B73DC;
}
</style>
<style lang="scss" scoped>
.print {
  display: flex;
  width: 100%;
  height: 100%;

  .el-button.qjc-fts-16 {
    font-size: 15px;
  }

  .left-menus {
    min-width: 170px;
    width: 170px;
    padding: 0 24px 30px;
    border-right: 1px solid #E5E8F5;
    background-color: #ffffff;
    overflow-y: auto;

    .add-action {
      display: flex;
      align-items: center;
      cursor: pointer;

      .add-action-img {
        display: flex;
        align-items: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background-color: #6883FB;
        border-radius: 50%;

        &::after {
          content: "+";
          width: 100%;
          font-size: 20px;
          color: #fff;
          text-align: center;
          margin-bottom: 4px;
        }
      }

      .add-action-text {
        font-size: 14px;
        color: #6883FB;
        margin-left: 8px;
      }
    }

    .left-list {
      padding-top: 20px;
    }

    .left-enp-item {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #525866;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        color: #7A92FB;
      }
    }

    .left-enp-item-active {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #6883FB;
      cursor: pointer;
    }

    .enp-item-status {
      width: 20px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF5219;
      background-color: #FDE8E2;
      margin-right: 4px;
      padding-top: 1px;
      border-radius: 50%;
      text-align: center;
    }

    .enp-item-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .enp-item-status-active {
      width: 20px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6883FB;
      background-color: #DCE3FF;
      margin-right: 4px;
      padding-top: 1px;
      border-radius: 50%;
      text-align: center;
    }
  }

  .right-wrap {
    position: relative;
    flex: 1;
    min-width: 1050px;
    padding: 28px 24px;

    &-header {
      display: grid;
      grid-template-columns: 1fr auto;
    }

    .query-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .query-package {
        width: 226px;
      }
    }

    .c-danger {
      color: #FF4C52;
    }

    .query-date {
      display: flex;
      align-items: center;
      margin-left: 32px;

      .query-date-label {
        margin-right: 10px;
      }
    }

    .query-btn {
      width: 72px;
      height: 36px;
      line-height: 36px;
      font-size: 15px;
      padding: 0;
      margin-left: 16px;
      border: none;
      color: #fff;
    }

  }

  .search {
    display: flex;
    align-items: center;
    gap: 10px;
    // justify-content: space-between;
    // margin-top: 0.32px;

    .el-input {
      width: 226px;
    }

    .el-button {
      // width: 96px;
      // height: 34px;
      // font-size: 14px;
      // font-family: PingFangSC-Medium, PingFang SC;
      // font-weight: 400;
      // color: #FFFFFF;
      // background: #6883FB;
      // border-radius: 17px;
      // border: none;
    }

    .el-button:active {
      background-color: #5B73DC;
    }

    .search-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 36px;
    }
  }

  .list {
    margin-top: 16px;

    &::before {
      display: none;
    }

    .el-button {
      font-size: 14px;
      padding: 6px 8px;
      border: none;

      +.el-button {
        margin-left: 4px;
      }
    }
  }

  .pagination {
    // margin-top: 24px;
    flex: 1;
    padding-right: 24px;
    text-align: center;
    margin-top: 24px;
    background-color: #fff;
  }
}

.el-select-dropdown__item.selected {
  color: #6681FA;
}

#iframe {
  height: 0;
}

.nextBtn {
  display: block;
  cursor: pointer;
  width: 96px;
  height: 34px;
  padding: 0 15px;
  background: rgb(102, 129, 250);
  border-radius: 2px;
  border: none;
  color: white;
  outline: none;
  font-size: 14px;
  border-radius: 17px;
  margin-left: 20px;
}

.no-print {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, .5);
  font-size: 18px;

  div {
    width: 500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;

    p {
      padding: 24px;
      border-bottom: 1px solid #ccc;
    }

    span {
      display: inline-block;
      padding: 12px 24px;
      cursor: pointer;
    }
  }
}

.empty-wrap {
  padding: 100px 0;
}

.empty-img {
  width: 222px;
  height: 206px;
}

.empty-text {
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #525866;
  // margin-top: 24px;
  line-height: 18px;
}

.footer-wrap {
  padding-top: 20px;
  display: flex;
  min-width: 1000px;
  max-width: 100%;
  width: 100%;
  height: 80px;
  background-color: #fff;
}

.btn-text {
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC;
}
</style>
